export default __webpack_public_path__ + "static/media/sunspotsActive.c328b83b.svg";